<template>
    <v-main>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-card flat tile>
              <v-card-title>
            <h2>This page doesn't exist. It may have never existed</h2>
                <p>Or it might have been deleted</p>
              </v-card-title>
              <v-card-subtitle>
            <h3>Sorry 'bout that</h3>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
</template>

<script>
export default {
  name: 'NotFound404',
};
</script>

<style scoped>

</style>
